import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import {
    ComplainSearch,
    Filter_Update_Request,
} from "../../Models/RequestModels";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import {
    EntityCodes,
    ComplainSearch_GroupBy,
    AuthActionCodes,
    ModuleLicenceCodes,
    Priorities,
    JobConsole_Search_Mode,
} from "../../Models/EnumModels";
import { PMSService } from "../../Services/PMSService";
import { ListResponse } from "../../Models/ResponseModels";
import * as _ from "lodash";
import { ComplainService } from "../../Services/ComplainService";
import {
    TopFilterStatModel,
    SearchTextResult,
} from "../../Models/CommonModels";
import * as alasql from "alasql";
import {
    GenericMaster,
    GenericMaster_String,
    LocationLookup,
    CallDescriptionLookup,
    CallCategoryLookup,
    VIP,
    PropertyBasicInfo,
} from "../../Models/GlobalEntities";
import { Observable, of } from "rxjs";
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    switchMap,
} from "rxjs/operators";
import {
    NgbTypeaheadSelectItemEvent,
    NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { JobSearchResult } from "../JobSearchResult/JobSearchResult";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { UserService } from "../../Services/UserService";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { untilDestroyed } from "ngx-take-until-destroy";
import {AppSettings} from "../../Library/AppSettings";

@Component({
    selector: "JobConsole",
    templateUrl: "./JobConsole.html",
})
export class JobConsole extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild("jobSearchResult") jobSearchResult: JobSearchResult;
    @ViewChild("consoleKey") consoleKey;
    @ViewChild("crisisSearchResult") crisisSearchResult: JobSearchResult;

    RequestModel: ComplainSearch;
    RequestModelCrisis: ComplainSearch;
    Model: ListResponse;
    _LocationId: number;
    DateFormat: string;
    PropStatModel: Array<TopFilterStatModel> = [];
    Timer: any;
    cDate: Date = new Date();
    SortParams: Array<GenericMaster_String> = [];
    SearchOnEntities: Array<EntityCodes> = [
        EntityCodes.CallCategories,
        EntityCodes.CallDescriptions,
        EntityCodes.Dept,
        EntityCodes.Location,
        EntityCodes.Sections,
        EntityCodes.Staff,
    ];

    lstLocations: Array<LocationLookup> = [];
    lstStaff: Array<GenericMaster> = [];
    lstCallDescriptions: Array<CallDescriptionLookup> = [];
    lstCallCategories: Array<CallCategoryLookup> = [];
    lstDepartments: Array<GenericMaster> = [];
    lstSections: Array<GenericMaster> = [];
    lstProperties: Array<PropertyBasicInfo> = [];
    KeywordSearch: string = null;

    MasterCache: any = {};

    _ComplainSearch_GroupBy = ComplainSearch_GroupBy;
    GroupTypes: Array<GenericMaster> = [];
    Search_Mode: JobConsole_Search_Mode = JobConsole_Search_Mode.Crisis;

    SelectedProperties: Array<number> = [];
    AppSettings = AppSettings;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected pmsService: PMSService,
        public complainService: ComplainService,
        public userService: UserService,
        private modalService: NgbModal
    ) {
        super(translate, toastr, route, router, masterService);

        for (let row of Object.keys(ComplainSearch_GroupBy).filter(
            (a) => typeof ComplainSearch_GroupBy[a] === "number"
        )) {
            let obj = new GenericMaster();
            obj.Id = ComplainSearch_GroupBy[row];

            if (obj.Id == 0) {
                obj.Name = "CMB_DEF.NO_GROUPING";
            } else {
                obj.Name = "ENTITIES.ENTITIES_" + row.toString();
            }

            if (obj.Id == ComplainSearch_GroupBy.Property) {
                if (this.masterService.LoggedInUserData.Properties.length > 1)
                    this.GroupTypes.push(obj);
            } else {
                this.GroupTypes.push(obj);
            }
        }

        this.complainService.ComplainStatsChanged.pipe(
            untilDestroyed(this)
        ).subscribe((data) => {
            this.onComplainRowStatsChanged(data);
        });

        this.complainService.ComplainRowAdded.pipe(
            untilDestroyed(this)
        ).subscribe((data) => {
            this.onComplainRowAdded(data);
        });
    }

    ngOnDestroy(): void {
        window.clearInterval(this.Timer);
    }

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        this.lstProperties = this.masterService.GetProperties_ModuleLicenseCode(
            ModuleLicenceCodes.TritonRapidResponse
        );

        this.complainService.JobConsoleRefreshEvent.pipe(
            untilDestroyed(this)
        ).subscribe((ComplainId) => {
            this.onJobConsoleToUpdate(ComplainId);
        });

        this.InitRequestModel();

        this.PopulateTopFilters();
        this.SetTopStatusData();

        //this.onLoadFilter();

        this.SetData();
        this.ShowCrisisCalls();

        this.CreateCache();
    }

    InitRequestModel(): void {
        this.RequestModel = new ComplainSearch();
        this.RequestModel.SetDefaults();

        this.RequestModelCrisis = new ComplainSearch();
        this.RequestModelCrisis.SetDefaults();

        this.SetSearchProperties();
    }

    SetSearchProperties(): void {
        if (
            this.SelectedProperties == null ||
            (this.SelectedProperties.length == 0 &&
                this.lstProperties.length > 0)
        ) {
            let propId =
                this.masterService.GetDefaultProperty_ModuleLicenseCode(
                    ModuleLicenceCodes.TritonRapidResponse
                );

            if (propId != null) this.SelectedProperties.push(propId);
        }

        this.RequestModel.Properties = _.cloneDeep(this.SelectedProperties);
        this.RequestModelCrisis.Properties = _.cloneDeep(
            this.SelectedProperties
        );
    }

    PopulateTopFilters(): void {
        this.PropStatModel.push({
            Id: null,
            IconClass: "fa fa-bars",
            Label: "SHORT_NAME.SHORT_NAME_ALL",
            Value: 0,
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "OPN",
            IconClass: "fa fa-unlock-alt",
            Label: "SHORT_NAME.SHORT_NAME_OPN",
            Value: 0,
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "USN",
            IconClass: "fa fa-minus-square",
            Label: "SHORT_NAME.SHORT_NAME_UNS",
            Value: 0,
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "PRK",
            IconClass: "fa fa-hourglass-start",
            Label: "SHORT_NAME.SHORT_NAME_PRK",
            Value: 0,
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "SNL",
            IconClass: "fa fa-user-times",
            Label: "SHORT_NAME.SHORT_NAME_SNL",
            Value: 0,
        } as TopFilterStatModel);

        this.PropStatModel.push({
            Id: "CLS",
            IconClass: "fa fa-lock",
            Label: "SHORT_NAME.SHORT_NAME_CLS",
            Value: 0,
        } as TopFilterStatModel);
    }

    FindStatus(Status: string): TopFilterStatModel {
        return this.PropStatModel.find((value) => {
            return value.Id == Status;
        });
    }

    Transform_TopFilter(lst: any): void {
        let totalCount = 0;

        if (lst == null) {
            //console.info("A = " + this.PropStatModel.length);
            for (let i = 0; i < this.PropStatModel.length; i++) {
                let row = this.PropStatModel[i];

                if (row != null && row.Id != null) {
                    totalCount = totalCount + row.Value;
                }
            }
        } else {
            for (let i = 0; i < this.PropStatModel.length; i++) {
                let row = this.PropStatModel[i];

                if (row != null && row.Id != null) {
                    let count = alasql(
                        "Select SUM([Count]) as cnt from ? where StatusCode = ?",
                        [lst, row.Id]
                    );

                    row.Value = count[0].cnt;
                    totalCount = totalCount + row.Value;
                }
            }
        }

        //console.info("T = " + totalCount);

        this.FindStatus(null).Value = totalCount;
    }

    SetTopStatusData(): void {
        if (this.RequestModel.Priority == 4) {
            this.RequestModel['excludeCrisisJobFilter'] = true;
        } else {
            this.RequestModel['excludeCrisisJobFilter'] = false;
        }
        this.complainService
            .Complain_StatusCounts(this.RequestModel)
            .then((data) => {
                this.Transform_TopFilter(data);
            });
    }

    onTopFilter(StatusCode: string): void {
        this.RequestModel.StatusCode = StatusCode;
        this.SetTopStatusData();
        this.SetData();
    }

    onPropertyOpened(val: any): void {
        if (val == true)
            this.SelectedProperties = _.cloneDeep(this.RequestModel.Properties);
    }

    idxPropSelectedDropDown(PropertyId: number): number {
        return this.SelectedProperties.findIndex((a) => a == PropertyId);
    }

    onPropertySelected(PropertyId: number, eventData: any): void {
        let idx = this.idxPropSelectedDropDown(PropertyId);

        if (eventData.target.checked) {
            if (idx >= 0) return;

            this.SelectedProperties.push(PropertyId);
        } else {
            if (idx >= 0) {
                this.SelectedProperties.splice(idx, 1);
            }
        }
    }

    isPropSelected(id: number): boolean {
        if (this.RequestModel == null || this.RequestModel.Properties == null)
            return false;

        return this.RequestModel.Properties.findIndex((a) => a == id) >= 0;
    }

    onPropertyChange(): void {
        //this.RequestModel.PropertyId = PropertyId;
        if (this.SelectedProperties.length == 0) this.SetSearchProperties();

        this.RequestModel.Properties = _.cloneDeep(this.SelectedProperties);
        this.RequestModelCrisis.Properties = _.cloneDeep(
            this.SelectedProperties
        );
        this.onClearFilter();
        this.SetTopStatusData();
        this.SetData();
        this.CreateCache();
        this.ShowCrisisCalls();
    }

    SetData(): void {
        let pCode = this.RequestModel.StatusCode;
        if (this.RequestModel.Priority == 4) {
            this.RequestModel['excludeCrisisJobFilter'] = true;
        } else {
            this.RequestModel['excludeCrisisJobFilter'] = false;
        }
        if (this.RequestModel.GroupBy == ComplainSearch_GroupBy.None) {
            this.jobSearchResult.RequestModel = _.cloneDeep(this.RequestModel);
            this.jobSearchResult.Show();
            return;
        }

        this.complainService.SelectedJob = null;
        this.IsSubmitting = true;

        this.Model = new ListResponse();
        this.Model.Result = [];

        this.complainService
            .Complain_Search(this.RequestModel)
            .then((data) => {
                //console.info(data);

                this.Model = data;
                this.RequestModel.PageNumber = data.CurrentPage;
                this.IsSubmitting = false;
            })
            .catch((reason) => {
                this.IsSubmitting = false;
            });
    }

    ShowCrisisCalls() {
        this.RequestModelCrisis.Priority = Priorities.Crisis;
        this.crisisSearchResult.RequestModel = _.cloneDeep(
            this.RequestModelCrisis
        );
        // this.Search_Mode = JobConsole_Search_Mode.Crisis;
        this.crisisSearchResult.Show();
    }

    IsAllSelected() {
        let toReturn = true;
        for (let row of this.lstProperties) {
            if (this.idxPropSelectedDropDown(row.PropertyId) < 0) {
                toReturn = false;
            }
        }
        return toReturn;
    }

    IsSomeSelected() {
        let toReturn = false;
        let allSelected = true;
        for (let row of this.lstProperties) {
            if (this.idxPropSelectedDropDown(row.PropertyId) >= 0) {
                toReturn = true;
            } else {
                allSelected = false;
            }
        }
        if (allSelected) return false;
        else return toReturn;
    }

    MasterToggle($event: any) {
        for (let row of this.lstProperties) {
            this.onPropertySelected(row.PropertyId, $event);
        }
    }

    onAssignedToMe(): void {
        this.RequestModel.AssignedTo = [
            this.masterService.LoggedInUserData.StaffId,
        ];
        this.RequestModel.LoggedBy = [];
        this.SetData();
    }

    onLoggedToMe(): void {
        this.RequestModel.LoggedBy = [
            this.masterService.LoggedInUserData.StaffId,
        ];
        this.RequestModel.AssignedTo = [];
        this.SetData();
    }

    onFilter(row: GenericMaster_String): void {
        this.RequestModel.OrderBy = row.Id;
        this.SetData();
    }

    CreateCache(): void {
        this.MasterCache[EntityCodes.Location] = [];
        this.MasterCache[EntityCodes.CallDescriptions] = [];
        this.MasterCache[EntityCodes.CallCategories] = [];
        this.MasterCache[EntityCodes.Staff] = [];
        this.MasterCache[EntityCodes.Dept] = [];
        this.MasterCache[EntityCodes.Sections] = [];

        for (let i = 0; i < this.RequestModel.Properties.length; i++) {
            let propID = this.RequestModel.Properties[i];

            let objProp =
                this.masterService.Cache_PropertyMainMasters.getValue(propID);

            if (objProp != null) {
                let res: Array<any>;

                this.MasterCache[EntityCodes.Location] = this.MasterCache[
                    EntityCodes.Location
                ].concat(objProp.Location);
                this.MasterCache[EntityCodes.CallDescriptions] =
                    this.MasterCache[EntityCodes.CallDescriptions].concat(
                        alasql(
                            "Select * from ? where Id not in (Select Id from ?)",
                            [objProp.CallDescriptions, this.lstCallDescriptions]
                        )
                    );
                this.MasterCache[EntityCodes.CallCategories] = this.MasterCache[
                    EntityCodes.CallCategories
                ].concat(
                    alasql(
                        "Select * from ? where Id not in (Select Id from ?)",
                        [objProp.CallCategories, this.lstCallCategories]
                    )
                );
                this.MasterCache[EntityCodes.Staff] = this.MasterCache[
                    EntityCodes.Staff
                ].concat(
                    alasql(
                        "Select * from ? where Id not in (Select Id from ?)",
                        [objProp.Staff, this.lstStaff]
                    )
                );
                this.MasterCache[EntityCodes.Dept] = this.MasterCache[
                    EntityCodes.Dept
                ].concat(
                    alasql(
                        "Select * from ? where Id not in (Select Id from ?)",
                        [objProp.Dept, this.lstDepartments]
                    )
                );
                this.MasterCache[EntityCodes.Sections] = this.MasterCache[
                    EntityCodes.Sections
                ].concat(
                    alasql(
                        "Select * from ? where Id not in (Select Id from ?)",
                        [objProp.Sections, this.lstSections]
                    )
                );
            }
        }
    }

    SearchFilter_DisplayText(value: SearchTextResult): string {
        if (value == null) return "";

        if (typeof value !== "object") return value;

        return value.Term;
    }

    SearchString = (term$: Observable<string>) =>
        term$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            //tap(() => this.searching = true),
            switchMap((term) =>
                this.onSearch(term).pipe(
                    //tap(() => this.searchFailed = false),
                    catchError(() => {
                        //this.searchFailed = true;
                        return of([]);
                    })
                )
            )
            //tap(() => this.searching = false)
        );

    SearchOnList(term: string, Entity: EntityCodes): SearchTextResult {
        let res = new SearchTextResult();
        res.Entity = Entity;
        res.EntityName = Entity.toString();
        res.Term = term;
        res.ItemCount = 0;

        let lst: Array<any> = this.MasterCache[Entity];
        if (lst == null || lst.length == 0) return res;

        let str = term.toUpperCase();
        let count: number = 0;

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];

            let name = "";

            switch (Entity) {
                case EntityCodes.CallCategories:
                case EntityCodes.CallDescriptions:
                case EntityCodes.Location:
                    name = row.Description;
                    break;
                case EntityCodes.Staff:
                case EntityCodes.Dept:
                case EntityCodes.Sections:
                    name = row.Name;
            }

            if (name != null && name.length > 0) {
                if (name.toUpperCase().indexOf(str) >= 0) {
                    count++;
                }
            }
        }

        res.ItemCount = count;

        return res;
    }

    SearchOnList_GetItems(term: string, Entity: EntityCodes): Array<number> {
        let res = new Array<number>();

        let lst: Array<any> = this.MasterCache[Entity];
        if (lst == null || lst.length == 0) return res;

        let str = term.toUpperCase();

        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];

            let name = "";

            switch (Entity) {
                case EntityCodes.CallCategories:
                case EntityCodes.CallDescriptions:
                case EntityCodes.Location:
                    name = row.Description;
                    break;
                case EntityCodes.Staff:
                case EntityCodes.Dept:
                case EntityCodes.Sections:
                    name = row.Name;
            }

            if (name != null && name.length > 0) {
                if (name.toUpperCase().indexOf(str) >= 0) {
                    res.push(row.Id);
                }
            }
        }

        return res;
    }

    onSearch(term: string): any {
        let result: Array<SearchTextResult> = [];
        if (term == null || term.length == 0) {
            return of(result);
        }

        if (term == null || term.length <= 1) {
            if (_.toNumber(term) >= 0) {
                let rCN = new SearchTextResult();
                rCN.Entity = EntityCodes.Complain;
                rCN.EntityName = "CallNo";
                rCN.Term = term;
                rCN.ItemCount = 0;

                result.push(rCN);
            }

            return of(result);
        }

        this.SearchOnEntities.map((ent) => {
            let row = this.SearchOnList(term, ent);
            if (row.ItemCount > 0) result.push(row);
        });

        let rG = new SearchTextResult();
        rG.Entity = EntityCodes.None;
        rG.EntityName = "Guests";
        rG.Term = term;
        rG.ItemCount = 0;

        result.push(rG);

        let nTerm: any = term;

        //console.info(_.toNumber(term));

        if (_.toNumber(term) >= 0) {
            let rCN = new SearchTextResult();
            rCN.Entity = EntityCodes.Complain;
            rCN.EntityName = "CallNo";
            rCN.Term = term;
            rCN.ItemCount = 0;

            result.push(rCN);
        }

        return of(result);
    }

    onSearchFilter(sel: NgbTypeaheadSelectItemEvent): void {
        let data: SearchTextResult = sel.item;

        let pCode = this.RequestModel.StatusCode;

        this.RequestModel = new ComplainSearch();
        this.RequestModel.SetDefaults();

        this.RequestModel.StatusCode = pCode;
        this.SetSearchProperties();

        this.RequestModel.Keyword = null;

        let req = this.RequestModel;

        let res = this.SearchOnList_GetItems(data.Term, data.Entity);

        switch (data.Entity) {
            case EntityCodes.CallCategories:
            case EntityCodes.CallDescriptions:
            case EntityCodes.Sections:
                req[data.Entity] = res;
                break;
            case EntityCodes.Location:
                req.Locations = res;
                break;
            case EntityCodes.Staff:
                req.AssignedTo = res;
                break;
            case EntityCodes.Dept:
                req.Departments = res;
                break;
            case EntityCodes.Complain:
                req.CallNo = _.toNumber(data.Term);
                break;
            case EntityCodes.None:
                req.Keyword = data.Term;
                break;
        }
        this.SetTopStatusData();
        this.SetData();
    }

    onSelected(Model: any): void {
        this.complainService.SelectedJob = Model;
    }

    onGroupingChanged(): void {
        this.SetData();
    }

    onClearGrouping() {
        this.RequestModel.GroupBy = ComplainSearch_GroupBy.None;
        this.onGroupingChanged();
    }

    onClearFilter(): void {
        let currentGrouping = this.RequestModel.GroupBy;
        this.InitRequestModel();
        this.KeywordSearch = null;
        if (currentGrouping !== ComplainSearch_GroupBy.None) {
            this.RequestModel.GroupBy = currentGrouping;
        }
        this.SetData();
        this.SetTopStatusData();
    }

    onResetToAll(): void {
        this.InitRequestModel();
        this.KeywordSearch = null;
        this.RequestModel.StatusCode = null;
        this.SetData();
    }

    onJobConsoleToUpdate(ComplainId: number): void {
        this.SetTopStatusData();
        //this.SetData();
    }

    onComplainRowAdded(data: any): void {
        if (
            this.RequestModel.Properties.findIndex(
                (a) => a == data.PropertyId
            ) >= 0
        ) {
            let rowStatus = this.FindStatus(data.CurrentStatus);
            rowStatus.Value = rowStatus.Value + 1;
            this.Transform_TopFilter(null);
        }
    }

    onComplainRowStatsChanged(data: any): void {
        if (this.PropStatModel == null) return;

        if (data.PrevOLTPData != null && data.OLTPData != null) {
            if (
                this.RequestModel.Properties.findIndex(
                    (a) => a == data.OLTPData.PropertyId
                ) >= 0
            ) {
                let rowC = this.FindStatus(data.OLTPData.CurrentStatus);
                rowC.Value = rowC.Value + 1;
            }

            if (
                this.RequestModel.Properties.findIndex(
                    (a) => a == data.PrevOLTPData.PropertyId
                ) >= 0
            ) {
                let rowP = this.FindStatus(data.PrevOLTPData.CurrentStatus);
                rowP.Value = rowP.Value - 1;
                if (rowP.Value < 0) rowP.Value = 0;
            }

            this.Transform_TopFilter(null);
        }
    }

    RefreshData(): void {
        this.SetTopStatusData();
        this.SetData();
        this.ShowCrisisCalls();
    }

    onFilterSave(): void {
        if (this.RequestModel == null) return;

        let data = _.cloneDeep(this.RequestModel);
        data.PageNumber = 1;

        let str = JSON.stringify(data);

        let req = new Filter_Update_Request();
        req.EntityCode = EntityCodes.Complain;
        req.JSONData = str;

        this.userService.Filter_Update(req).then((data) => {
            this.GetMultilingualToast("TS.TS_GENERAL_SAVED", "success");
        });
    }

    onLoadFilter(): void {
        let req = EntityCodes.Complain;
        this.userService.FilterSave_GetJSON(req).then((data) => {
            if (data == null) {
                //if (this.Model == null)
                //    this.SetData();

                return;
            }
            data.Properties = data.Properties.filter((a) =>
                this.masterService.CheckActiveLicence_Module(
                    a,
                    ModuleLicenceCodes.TritonRapidResponse
                )
            );
            if (data.Properties.length > 0) {
                let obj: any = data;
                this.RequestModel = new ComplainSearch();
                this.RequestModel.SetDefaults();
                this.RequestModel = _.assign(this.RequestModel, obj);
                this.KeywordSearch = null;
                if (this.RequestModel.Keyword)
                    this.KeywordSearch = this.RequestModel.Keyword;
                if (this.RequestModel.CallNo)
                    this.KeywordSearch = this.RequestModel.CallNo.toString();
                this.SelectedProperties = _.cloneDeep(
                    this.RequestModel.Properties
                );
                this.SetData();
                this.SetTopStatusData();
            }
        });
    }

    OpenKeyModal(): void {
        let ngbModalOptions: NgbModalOptions = {
            backdrop: "static",
            size: "lg",
            centered: true,
        };
        this.modalService.open(this.consoleKey, ngbModalOptions);
    }

    isServiceStaff(): boolean {
        const loggedInUser = this.masterService.LoggedInUserData;
        return loggedInUser && loggedInUser.IsServiceStaff;
    }
}
